import { createContext, useContext } from 'react';
import type { ConfirmRequest, PatientBanner, Slot } from '@ampshift/shared';

/** Actions surfaces can trigger. Every one of them goes back through the conversation endpoints. */
export interface SurfaceActions {
  /** Sends text as a user message (clarification options, calendar quick actions). */
  sendMessage(text: string): void;
  /** POST /v1/chat with a structured `form` payload. */
  submitForm(formId: string, values: Record<string, string>): void;
  /** Slot picker → `{ formId: 'slot-pick', values: { providerId, start, appointmentTypeCode } }`. */
  pickSlot(slot: Slot): void;
  /** POST /v1/chat/confirm. */
  confirm(req: ConfirmRequest): Promise<void>;
  /** patient-indicator surface: updates the top bar rather than rendering inline. */
  setPatientContext(patient: PatientBanner | null, activeEncounterId: string | null): void;
}

export const SurfaceActionsContext = createContext<SurfaceActions>({
  sendMessage: () => {},
  submitForm: () => {},
  pickSlot: () => {},
  confirm: async () => {},
  setPatientContext: () => {},
});

export function useSurfaceActions(): SurfaceActions {
  return useContext(SurfaceActionsContext);
}
